import { format } from "date-fns";
import React from "react";

import { getLocalTime } from "../utils/datetime";

const LocalTime = ({ locality, date = null }) => {
  const formatLocalTime = () => {
    try {
      const localTime = getLocalTime(locality, date);
      if (!localTime || isNaN(localTime.getTime())) {
        return "N/A";
      }
      return format(localTime, "h:mma");
    } catch (error) {
      return "N/A";
    }
  };

  return (
    <span>
      The time in {locality?.name || ""} is {formatLocalTime()}
    </span>
  );
};

export default LocalTime;
